import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStrategicCommercialZonesInputDto, StrategicCommercialZoneCreateDto, StrategicCommercialZoneDto, StrategicCommercialZoneExcelDownloadDto, StrategicCommercialZoneUpdateDto } from '../dtos/strategic-commercial-zone/models';

@Injectable({
  providedIn: 'root',
})
export class StrategicCommercialZoneService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: StrategicCommercialZoneCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StrategicCommercialZoneDto>({
      method: 'POST',
      url: '/api/planning/strategicCommercialZones',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/strategicCommercialZones/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/strategicCommercialZones',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StrategicCommercialZoneDto>({
      method: 'GET',
      url: `/api/planning/strategicCommercialZones/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/strategicCommercialZones/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStrategicCommercialZonesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StrategicCommercialZoneDto>>({
      method: 'GET',
      url: '/api/planning/strategicCommercialZones',
      params: { name: input.name, remsoftName: input.remsoftName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StrategicCommercialZoneExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/strategicCommercialZones/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, remsoftName: input.remsoftName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StrategicCommercialZoneDto[]>({
      method: 'GET',
      url: '/api/planning/strategicCommercialZones/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StrategicCommercialZoneUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StrategicCommercialZoneDto>({
      method: 'PUT',
      url: `/api/planning/strategicCommercialZones/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}